import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../../data/content";

export default function Ribbon() {
  return (
    <div className="border-y border-black/5 bg-ajmus-navy py-5" data-testid="marquee-ribbon">
      <Marquee speed={38} gradient={false} autoFill pauseOnHover>
        {MARQUEE_ITEMS.map((item, i) => (
          <div key={`${item}-${i}`} className="flex items-center">
            <span className="px-8 font-heading text-lg font-bold tracking-tight text-white/85">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-health-soft" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
